import apiFinancial from "../config/api_financial";
// import axios from "axios";
import getHeaders from "./getHeaders";

// const apiFinancial = axios.create({
//   baseURL: "http://localhost:8086",
// });

function findAllFinancialNaturesByGroupIdAndFarmId(payload) {
  const { groupId, farmId, signal } = payload;

  return apiFinancial.get(
    `/bovexo/${groupId}/farms/${farmId}/financial/natures`,
    getHeaders(false, signal)
  );
}

function createNewFinancialNature(payload) {
  const { groupId, farmId, body, signal } = payload;

  if (body.farmId) {
    return apiFinancial.post(
      `/bovexo/${groupId}/farms/${farmId}/financial/natures`,
      body,
      getHeaders(false, signal)
    );
  }
  return apiFinancial.post(
    `/bovexo/${groupId}/farms/financial/natures`,
    body,
    getHeaders(false, signal)
  );
}

function updateFinancialNature(payload) {
  const { groupId, farmId, id, body, signal } = payload;

  if (body.farmId) {
    return apiFinancial.put(
      `/bovexo/${groupId}/farms/${farmId}/financial/natures/${id}`,
      body,
      getHeaders(false, signal)
    );
  }
  return apiFinancial.put(
    `/bovexo/${groupId}/farms/financial/natures/${id}`,
    body,
    getHeaders(false, signal)
  );
}

export {
  findAllFinancialNaturesByGroupIdAndFarmId,
  createNewFinancialNature,
  updateFinancialNature,
};
